import { FC, useEffect, useState } from 'react';

import { DialogProps } from '@rikstv/play-common/src/components/coverPage/coverpage.types';
import { PlayerDialog } from '@rikstv/play-common/src/components/playerDialog';
import { Loader } from '@rikstv/shared-components';

import routerPath from '../../../common/router/router.path';
import { getNavigationUrlAndRecommendedProducts } from '../../packages/utils/getRecommendedProduct';
import { PaymentPagePurposes } from '../../payment/containers/paymentpage.types';
import { getProductIds } from '../../products/utils/productHelpers';
import { HasActiveProducts, useCustomerSubscription } from '../../user/forces/hooks/useCustomerSubscription';
import { packageStates } from '../../user/forces/packageStates';

export const PlayerNoAccessDialog: FC<DialogProps['NoAccess']> = ({ channelId, posterUrl }) => {
  const { isLoading, subscription } = useCustomerSubscription();
  const [upgradeLink, setUpgradeLink] = useState('');

  useEffect(() => {
    getNavigationUrlAndRecommendedProducts({
      channelExternalIds: [channelId],
    }).then(recommendation => {
      setUpgradeLink(recommendation.url);
    });
  }, [channelId]);

  if (isLoading || !subscription) {
    return <Loader size="large" />;
  }

  if (subscription.state === packageStates.PENDING_PAYMENT_INFO) {
    return (
      <PlayerDialog
        heading="Du har dessverre ikke tilgang til dette innholdet"
        buttonText="Registrer betaling"
        description="For å kunne se må du registere betaling"
        posterUrl={posterUrl}
        linkOrClickHandler={routerPath.purchaseProducts(getProductIds(subscription), PaymentPagePurposes.PURCHASE)}
      />
    );
  }

  if (subscription.state === packageStates.PAYMENT_FAILED) {
    return (
      <PlayerDialog
        heading="Du har dessverre ikke tilgang til dette innholdet"
        buttonText="Endre betaling"
        description="Vi har ikke klart å trekke penger fra ditt kort eller konto"
        posterUrl={posterUrl}
        linkOrClickHandler={routerPath.accountSubscriptionPage()}
      />
    );
  }

  if (!HasActiveProducts(subscription)) {
    return (
      <PlayerDialog
        heading="Du har dessverre ikke tilgang"
        buttonText="Min konto"
        description="For å kunne se må du aktivere ditt abonnement. Gå til Min konto for å velge pakken som passer deg."
        posterUrl={posterUrl}
        linkOrClickHandler={routerPath.account()}
      />
    );
  }

  if (upgradeLink) {
    return (
      <PlayerDialog
        heading="Oi, du har ikke tilgang til dette innholdet"
        buttonText="Oppgrader her"
        description={'Heldigvis kan du få det ved å oppgradere'}
        posterUrl={posterUrl}
        linkOrClickHandler={upgradeLink}
      />
    );
  }

  return (
    <PlayerDialog
      heading="Du har dessverre ikke tilgang til dette innholdet"
      buttonText="Kontakt oss"
      description="Ta kontakt med oss for å finne ut hvordan du kan få tilgang"
      posterUrl={posterUrl}
      linkOrClickHandler={routerPath.help()}
    />
  );
};
